<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="pb-12">
          <setup-work-session-container-view />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupWorkSessionContainerView: () => import('@/components/hris/setup/work-session/ContainerView'),
    },
  }
</script>
